import { render, staticRenderFns } from "./notifications-container.vue?vue&type=template&id=51b945f8&"
import script from "./notifications-container.vue?vue&type=script&lang=js&"
export * from "./notifications-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports